import { FloatButton } from "antd";

import ManualAnchor from "../components/ERPSyncManual/ManualAnchor";
import ManualContent from "../components/ERPSyncManual/ManualContent";

import "./ERPSyncManual.css";

const ERPSyncManual = () => {
  return (
    <div className="erp-sync-manual">
      <ManualAnchor />
      <ManualContent />
      <FloatButton.BackTop />
    </div>
  );
};

export default ERPSyncManual;
